module.exports = __webpack_public_path__ + "img/ico_error.6689e84.svg";